document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('.product__accordion details');

  accordions.forEach(function (details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    content.style.transition = 'max-height 1.4s ease, opacity 1.4s ease';
    content.style.maxHeight = '0px';
    content.style.opacity = '0';

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = details.hasAttribute('open');

      if (isOpen) {
        // Closing: set explicit current height first, then animate to 0
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
        });
        setTimeout(function () {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 300);
      } else {
        // Opening: set open first so content is measurable, then animate
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.opacity = '1';
        });
      }
    });
  });
});